import { PdpCatalogFulfillmentType, PdpDeliveryType } from '../../graphql/select-option_types.2';

export const checkZigzinOrVendorFlexFulfillmentType = (fulfillment_type: PdpCatalogFulfillmentType | null) => {
  if (!fulfillment_type) {
    return false;
  }

  return (
    fulfillment_type === PdpCatalogFulfillmentType.ZIGZIN || fulfillment_type === PdpCatalogFulfillmentType.VENDOR_FLEX
  );
};

export const checkZigzinOrVendorFlexDeliveryType = (delivery_type: PdpDeliveryType | null) => {
  if (!delivery_type) {
    return false;
  }

  return delivery_type === PdpDeliveryType.ZIGZIN || delivery_type === PdpDeliveryType.VENDOR_FLEX;
};
